export const PHONE_SUPPORT_KEY = 'support';
const PHONE_MO_KEY = 'mo';
const PHONE_SPB_KEY = 'spb';
const PHONE_OTHER_KEY = 'other';

const EMAIL_KEY = 'email';
export const EMAIL = 'clickme@hh.ru';

export const CONTACT_ITEMS = [PHONE_MO_KEY, PHONE_SPB_KEY, PHONE_OTHER_KEY, EMAIL_KEY];
